import { render, staticRenderFns } from "./ColorPalettePanel.vue?vue&type=template&id=7ba98eef&scoped=true"
import script from "./ColorPalettePanel.vue?vue&type=script&lang=ts"
export * from "./ColorPalettePanel.vue?vue&type=script&lang=ts"
import style0 from "./ColorPalettePanel.vue?vue&type=style&index=0&id=7ba98eef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba98eef",
  null
  
)

export default component.exports